import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthUtils } from './auth.utils';

export const authGuard: CanActivateFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    const token = authService.accessToken;

    if (token && !AuthUtils.isTokenExpired(token)) {
        return true;
    }

    // Token is missing or expired - redirect to home
    localStorage.removeItem('token');
    router.navigate(['/']);
    return false;
};
